export const getHashHex = async (encodedData: Uint8Array): Promise<string> => {
  // Generate buffer
  const hash = new Uint8Array(await crypto.subtle.digest('SHA-1', encodedData));
  // Convert buffer to byte array
  const hashArray = Array.from(new Uint8Array(hash));
  // Create hex string from byte array
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};
